var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.5625C6.3401 2.5625 2.5625 6.3401 2.5625 11C2.5625 15.6599 6.3401 19.4375 11 19.4375C15.6599 19.4375 19.4375 15.6599 19.4375 11C19.4375 6.3401 15.6599 2.5625 11 2.5625ZM0.6875 11C0.6875 5.30456 5.30456 0.6875 11 0.6875C16.6954 0.6875 21.3125 5.30456 21.3125 11C21.3125 16.6954 16.6954 21.3125 11 21.3125C5.30456 21.3125 0.6875 16.6954 0.6875 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.5446C12.4497 10.5446 13.625 9.38737 13.625 7.95982C13.625 6.53226 12.4497 5.375 11 5.375C9.55025 5.375 8.375 6.53226 8.375 7.95982C8.375 9.38737 9.55025 10.5446 11 10.5446Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1845 11.2832H14.1573C13.7853 11.2832 13.4133 11.3739 13.0776 11.5372L12.0796 12.0363C11.3992 12.372 10.6099 12.372 9.92943 12.0453L8.88609 11.5372C8.5504 11.3739 8.1875 11.2923 7.81552 11.2923C6.46371 11.2923 5.375 12.381 5.375 13.7329C5.375 14.9071 6.1554 15.9531 7.3036 16.1987C10.0186 16.7794 12.062 16.7564 14.6953 16.1939C15.8424 15.9489 16.625 14.9058 16.625 13.7329C16.625 12.372 15.5272 11.2832 14.1845 11.2832Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientData);
export default __webpack_public_path__ + "static/media/patient_data.08e4b3db33f7a4e93a2758d2af5d98c3.svg";
export { ForwardRef as ReactComponent };